import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import en from 'intl/translations/en';
import { getMultiCam } from 'selectors/multiCam';

import BigPlus from '../icons/BigPlus';

interface FillerWrapperProps {
  isLink?: boolean;
  children?: ReactNode;
  isPrimary?: boolean;
}

const FillerWrapper = ({
  isLink = false,
  children = null,
  isPrimary = false,
}: FillerWrapperProps) =>
  isLink ? (
    <a
      className="sl-multi-cam__cam-filler"
      href={isPrimary ? '/setup/favorite-surf-spots' : ''}
      tabIndex={0}
    >
      {children}
    </a>
  ) : (
    <div className="sl-multi-cam__cam-filler">{children}</div>
  );

interface CamFillerProps {
  camIndex: number;
}

const CamFiller = ({ camIndex }: CamFillerProps) => {
  const { numCams, active, primarySpotIndex } = useSelector(getMultiCam);

  const isPrimary = primarySpotIndex === camIndex;
  const hasEnoughFavorites = active?.spots?.length > numCams;

  return (
    <FillerWrapper isLink={!hasEnoughFavorites} isPrimary={isPrimary}>
      <BigPlus pulse />
      <h1 className="sl-multi-cam__cam-filler__text">
        {en.MultiCam.cam.filler(hasEnoughFavorites)}
      </h1>
    </FillerWrapper>
  );
};

export default CamFiller;
